import { connect } from 'react-redux'
import AppOrchard from './AppOrchard'
import { handleLogin } from './module'

const mapActionCreators = {
  handleLogin,
}

const mapStateToProps = state => ({
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(AppOrchard)



// WEBPACK FOOTER //
// ./src/legacy/pages/AppOrchard/container.jsx